import { $get, $post } from "../utils/request.js";

export default {
  electronicMedicine(data) {
    return $post("/xsts/electronic_medicine", data);
  },
};
